let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hMDX9"), load("gGGz0")]).then(() => parcelRequire('fiSL0'));